import { useLiveCommerceProducts } from "features/shopifyLiveCommerce/useLiveCommerceProducts";
import { useMemo } from "react";
import { useSelector } from "store";
import { isFeatureEnabled } from "utility/isFeatureEnabled";

import { selectLiveCommerceGoods } from "./liveCommerce/selectLiveCommerceGoods";

import type { Store } from "store";

/**
 * 配信ナビに出すライブコマース商品。
 *
 * newLiveCommerceは公開前の一時フラグ。公開後はFirestore分岐
 * (state.ticket.eventGoods)とisFeatureEnabledを消し、
 * useLiveCommerceProductsだけを残す(isLiveCommerceEnabledの条件は残す)。
 * 購入パネル側の削除はStreamingLiveCommerce.tsxを参照。
 */
export const useStreamingNavigationGoods = (
  isLiveCommerceEnabled: boolean
): {
  thumbnailUrl: string;
  goodsName: string;
} => {
  const isAdmin = useSelector((state: Store) => state.admin.isAdmin);
  const eventId = useSelector(
    (state: Store) => state.event.displayEvent
  )?.eventId;
  const uid = useSelector((state: Store) => state.auth.user.uid);
  const legacyGoods = useSelector((state: Store) => state.ticket.eventGoods);
  const isNewLiveCommerce = isFeatureEnabled({
    featureName: "newLiveCommerce",
  });
  // フラグOFF、またはライブコマースを使わないイベントではeventIdにundefinedを渡し、
  // useLiveCommerceProducts側でSWRキーがnullになってAPIを叩かない
  const shopifyProducts = useLiveCommerceProducts(
    isNewLiveCommerce && isLiveCommerceEnabled ? eventId : undefined,
    Boolean(uid)
  );
  const source = isNewLiveCommerce ? shopifyProducts : legacyGoods;
  const selected = useMemo(
    () => selectLiveCommerceGoods(source, isAdmin),
    [source, isAdmin]
  );
  const first = selected[0];

  return {
    thumbnailUrl: first?.thumbnail ?? "",
    goodsName: first?.name ?? "",
  };
};
